module.exports = __webpack_public_path__ + "img/value-blocks-slider-chevy.f02b7cc5.png";